const exportToCSV = (sortedData, tableColumns, exportFileName) => {
  const csvContent = [
    tableColumns.filter(col => col.key !== 'actions').map(col => col.header).join(','),
    ...sortedData.map(item => 
      tableColumns.filter(col => col.key !== 'actions').map(col => {
        let value = item[col.key];
        if (typeof value === 'object' && value !== null) {
          value = JSON.stringify(value);
        }
        // Escape quotes and wrap in quotes if contains comma or quote
        if (value && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          value = `"${value.replace(/"/g, '""')}"`;
        }
        return value || '';
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${exportFileName}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  
  return { success: true };
};

export { exportToCSV };
